// extracted by mini-css-extract-plugin
export default {"acceptBtn":"ActionButtonWithConfirm_acceptBtn__lKIZX","placeHolderShimmer":"ActionButtonWithConfirm_placeHolderShimmer__fvgDd"};